// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../../../cms/index.generated';
import { SubMenuFragmentDoc } from './SubMenu.fragment.generated';
import { SubMenuSectionFragmentDoc } from './SubMenuSection.fragment.generated';
import { SubMenuItemFragmentDoc } from './SubMenuItem.fragment.generated';
import { CmsImageSizesFragmentDoc } from '../../../../cms/cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../../cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../../cms/imageSize.fragment.generated';
import { SubMenuEditorialContentFragmentDoc } from './SubMenuEditorialContent.fragment.generated';
export const HeaderMenuFragmentDoc = `
    fragment headerMenu on MenuItem {
  __typename
  title
  hideOnMobile
  hideOnDesktop
  link {
    ...link
  }
  subMenu {
    ...subMenu
  }
}
    `;